var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgForklift(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 24 24",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#000"
    },
    x: 4.9,
    y: 8.2,
    width: 1.4,
    height: 3.8
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#000"
    },
    points: "10.3,8.2 8.3,8.2 8.3,14.1 12.4,14.1 12.4,13.4 10.5,8.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#000"
    },
    points: "16.6,16.2 16.6,6.5 15.1,6.5 15.1,16.2 15.1,17.2 15.1,17.4 23,17.4 23,16.2  "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#000"
    },
    d: "M6.3,17.4c-0.1-1.2-1.1-2.2-2.3-2.2s-2.2,0.9-2.3,2.2c0,0,0,0.1,0,0.2C1.7,18.9,2.7,20,4,20s2.3-1.1,2.3-2.3 C6.4,17.6,6.4,17.5,6.3,17.4z M4.5,18.1c-0.1,0.1-0.3,0.2-0.5,0.2c-0.2,0-0.4-0.1-0.5-0.2c-0.1-0.1-0.2-0.3-0.2-0.5 c0,0,0-0.1,0-0.1c0,0,0,0,0-0.1c0.1-0.3,0.4-0.5,0.7-0.5s0.6,0.2,0.7,0.5c0,0,0,0,0,0.1c0,0,0,0.1,0,0.1 C4.7,17.8,4.6,18,4.5,18.1z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#000"
    },
    d: "M14.3,17.4c-0.1-1.2-1.1-2.2-2.3-2.2s-2.2,0.9-2.3,2.2c0,0,0,0.1,0,0.2c0,1.3,1.1,2.3,2.3,2.3 s2.3-1.1,2.3-2.3C14.3,17.6,14.3,17.5,14.3,17.4z M12.5,18.1c-0.1,0.1-0.3,0.2-0.5,0.2s-0.4-0.1-0.5-0.2 c-0.1-0.1-0.2-0.3-0.2-0.5c0,0,0-0.1,0-0.1c0,0,0,0,0-0.1c0.1-0.3,0.4-0.5,0.7-0.5c0.3,0,0.6,0.2,0.7,0.5c0,0,0,0,0,0.1 c0,0,0,0.1,0,0.1C12.7,17.8,12.6,18,12.5,18.1z"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.5,14.1v-1l-2.7-7h-0.6V5.8H11c0-0.4,0-1.7-0.9-1.7c-0.9,0-0.8,1.3-0.8,1.7H9.1v0.3H4.8H3.1v2.1V12H1v5.5 h0.4c0.1-1.3,1.2-2.4,2.6-2.4s2.5,1.1,2.6,2.4h1.4h0.3h1.2c0.1-1.3,1.2-2.4,2.6-2.4s2.5,1.1,2.6,2.4h0.3v-3.3 C14.8,14.1,14.5,14.1,14.5,14.1z M6.2,12H4.9V8.2h1.4V12z M12.4,14.1H8.3V8.2h2h0.2l1.9,5.2V14.1z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgForklift);
export default __webpack_public_path__ + "static/media/forklift.76da229a03e47581e24f1699df8e2794.svg";
export { ForwardRef as ReactComponent };